import {
  FACEBOOK_KEY,
  REDDIT_KEY,
  YOUTUBE_KEY,
  SOCIAL_MEDIA_ICONS_MAP, INSTAGRAM_KEY,
  TIKTOK_KEY,
  FORUM_KEY,
  X_SOURCE_KEY
} from './components/constants/FeedCommentConstants';

const SUBREDDIT_NAME_IDEX = 4;
const ESTIMATED_PROCESSING_TIME_DECIMAL_PLACES = 2;

export const capitalizeWord = myWord => {
  let indexOfFirstLetter = 0;
  for (let i=0;i<myWord.length;i++) {
    if (myWord.charAt(i).match(/[a-z]/i)) {
      indexOfFirstLetter = i;
      break;
    }
  }
  return myWord.slice(0,indexOfFirstLetter) + myWord.charAt(indexOfFirstLetter).toUpperCase() + myWord.slice(indexOfFirstLetter+1);
}

export const capitalizeWords = phase => {
  const lowercaseWords = phase.split(" ");
  let capitalizedWords = [];
  for (const lowercaseWord of lowercaseWords) {
    const capitalizedWord = capitalizeWord(lowercaseWord);
    capitalizedWords.push(capitalizedWord);
  }
  return capitalizedWords.join(" ");
}

export const getLoginRedirectUrl = () => {
  const pageToRedictTo = '/login';
  if (window.location.search.length > 0) {
    return pageToRedictTo + window.location.search;
  }
  else {
    return pageToRedictTo;
  }
}

export const getFeedIconForReddit = (sourceLink) => {
  const sourceLinkList = sourceLink.split('/');
  const subreddit_key = sourceLinkList[SUBREDDIT_NAME_IDEX];
  return SOCIAL_MEDIA_ICONS_MAP[REDDIT_KEY][subreddit_key];
}

export const getDefaultRedditIcon = () => {
  return SOCIAL_MEDIA_ICONS_MAP[REDDIT_KEY][REDDIT_KEY]
}

export const getDefaultXIcon = () => {
  return SOCIAL_MEDIA_ICONS_MAP[X_SOURCE_KEY][X_SOURCE_KEY]
}

export const getFeedIconForYoutube = () => {
  return SOCIAL_MEDIA_ICONS_MAP[YOUTUBE_KEY][YOUTUBE_KEY];
}

export const getFeedIconForInstagram = () => {
  return SOCIAL_MEDIA_ICONS_MAP[INSTAGRAM_KEY][INSTAGRAM_KEY];
}

export const getFeedIconForFacebook = (source) => {
  return SOCIAL_MEDIA_ICONS_MAP[FACEBOOK_KEY][source];
}

export const getFeedIconForTiktok = () => {
  return SOCIAL_MEDIA_ICONS_MAP[TIKTOK_KEY][TIKTOK_KEY];
}

export const getFeedIconForForum = (source) => {
  return SOCIAL_MEDIA_ICONS_MAP[FORUM_KEY][source];
}

export const convertEstimationTimeStringFromHours = (topicPreviewEstimatedProcessingTimeInHours) => {
  const numberOfDays = Math.floor(topicPreviewEstimatedProcessingTimeInHours / 24);
  
  let timeLeftAfterSubtractingDays = topicPreviewEstimatedProcessingTimeInHours % 24;
  const numberOfHours = Math.floor(timeLeftAfterSubtractingDays);
  
  let timeLeftAfterSubtractingDaysAndHours = Number((timeLeftAfterSubtractingDays - numberOfHours).toFixed(ESTIMATED_PROCESSING_TIME_DECIMAL_PLACES));
  const numberOfMinutes = Math.ceil(timeLeftAfterSubtractingDaysAndHours * 60);

  return [numberOfDays, numberOfHours, numberOfMinutes];
}


// WEBPACK FOOTER //
// ./src/features/home/sharedFunctions.js